import Vue from "vue";
// 全局样式重置
import "@ajx-common/trth-web-common/assets/styles/reset.scss";
// 引进公共组件包的样式
import "@ajx-common/trth-web-common/dist/trth-web-common.css";
// 引入iconfont图标
import "@ajx-common/trth-web-common/assets/iconfont/iconfont.css";
// 引入文件图标iconfont
import "@ajx-common/trth-web-common/assets/file-type-iconfont/iconfont.css";
// 引入组件
import { Icon, SSO } from "@ajx-common/trth-web-common";
import {
  getToken,
  setToken,
  setTenantId,
  getTenantId,
  setBid,
  getBid,
} from "@/utils/auth";

Vue.component("icon", Icon);

export const ssoService = new SSO.SSOServices({
  project: SSO.SSO_CONFIG.FrontProject.SSO,
  env: process.env.NODE_ENV,
  getToken: getToken,
  setToken: setToken,
  getTenantId: getTenantId,
  setTenantId: setTenantId,
  getBid: getBid,
  setBid: setBid,
});

export const SSO_CONFIG = SSO.SSO_CONFIG;
